import axios from 'axios'
import axiosRetry from 'axios-retry'

const I18n = {
  namespaced: true,
  state: {
    enums: {}
  },
  mutations: {
    setEnums (state, data) {
      state.enums = data
    }
  },
  actions: {
    fetchI18nTranslation (context) {
      axiosRetry(axios, { retries: 2 })
      return axios.get('/api/i18n_reference').then(
        ({ data }) => {
          const i18n = data
          context.commit('setEnums', i18n)
        },
        (error) => {
          console.error(error)
        }
      )
    }
  }
}

export default I18n
